import { useEffect } from 'react';

// @ts-ignore
import { default as ltrStyle } from '!css-loader!sass-loader!../_metronic/assets/sass/style.scss'; // eslint-disable-line 
// @ts-ignore
import { default as rtlStyle } from '!css-loader!sass-loader!../_metronic/assets/css/style.rtl.css'; // eslint-disable-line 

export const useDynamicStyleSheet = (chosenTheme: string): void => {

    // const availableThemes = [ltrStyle, rtlStyle];
    const PreferredTheme = {LTR:ltrStyle , RTL: rtlStyle}
    const availableThemes = new Map<any, string>();
    availableThemes.set('ltr', PreferredTheme.LTR);
    availableThemes.set('rtl', PreferredTheme.RTL);
    // console.log(availableThemes);

    function injectCss(styles: any, chosenTheme: any) {
        // console.log('dynamic:','dynamicstylesheet'+chosenTheme);
        const id = `dynamicstylesheet${chosenTheme}`;
        let styleSheet = document.createElement("style");
        styleSheet.type = 'text/css';
        styleSheet.setAttribute("id", id);
        styleSheet.innerText = styles;
        document.head.appendChild(styleSheet);

        const htmlElement = document.querySelector("html");
        htmlElement?.setAttribute("direction", chosenTheme);
        htmlElement?.setAttribute("dir", chosenTheme);
        htmlElement?.style.setProperty('direction', chosenTheme);
    }

  useEffect( () => {
        // const newTheme = chosenTheme ==='rtl' ? availableThemes[0] : availableThemes[1];
        const newTheme = availableThemes.get(chosenTheme);
        // console.log(newTheme);
        // console.log("c:",chosenTheme);

        if(newTheme) {
            if(document.getElementById('dynamicstylesheet'+chosenTheme)){
                // console.log("exist");
            }else{
                // console.log("not exist");
                injectCss(newTheme, chosenTheme);
            }
        }

        // Remove all others
        availableThemes.forEach( (style, theme) => {
            if(theme !== chosenTheme) {
                const stylesheet = document.getElementById('dynamicstylesheet'+theme);
                // console.log('dynamicstylesheet'+theme);
                if (stylesheet) {
                    document.head.removeChild(stylesheet);
                }
            }
        });

    }, [chosenTheme])

    return;
};